tinymce.PluginManager.add('term', function (editor, url) {
	function addTermDecode() {
		const term = initTerm(this.active())

		if (term) {
			editor.windowManager.open({
				title: 'Ввести определение термина',
				width: 700,
				height: 400,
				body: [
					{type: 'textbox', name: 'title', label: 'Видимый текст', value: term.text},
					{type: 'textbox', multiline: true, flex: 1, name: 'body', value: term.def, label: 'Определение термина', minHeight: 300}
				],
				onsubmit: function (e) {
					setContent({
						selection: term.selection,
						text: e.data.title,
						definition: e.data.body
					})
				}
			})
		}
	}

	function initTerm(state) {
		let selection = editor.selection
		const selectionNode = selection.getNode()
		let selectionContent = selection.getContent()
		let definitionContent = ''

		const existSelection = !!selectionContent;
		const existTerm = !!state;

		if (!existSelection && !existTerm){
			return false
		}

		if (existTerm){
			selection.select(selectionNode)
			selectionContent = selectionNode.innerText
			definitionContent = selectionNode.getAttribute('title')
		}

		return {
			selection,
			text: selectionContent,
			def: definitionContent
		}
	}

	function setContent(term) {
		term.selection.setContent(`<dfn title="${term.definition}">${term.text}</dfn>`)
		editor.nodeChanged();
	}

	editor.addButton('term', {
		text: 'C',
		tooltip: 'Ввести определение сложного слова',
		onclick: addTermDecode,
		stateSelector: 'dfn[title]',
	});

	editor.addMenuItem('term', {
		text: 'C',
		tooltip: 'Ввести определение сложного слова',
		onclick: addTermDecode,
		stateSelector: 'dfn[title]',
		context: 'insert',
		prependToContext: true
	});
});
